enum ByProductEntryPoints {
  autocomplete = '/api/auto-complete/by-product',
}

export default ByProductEntryPoints;
